<!--
 * @Descripttion: 
 * @Author: liang
 * @Date: 2020-09-11 17:22:16
 * @LastEditors: liang
 * @LastEditTime: 2024-07-02 17:37:29
-->
<template>
  <div>
    <div class="main">
      <!-- <div id="secondnav">
      <div class="secondnav">
        <div class="title">政策法规</div>
        <div class="nav">
          <a
            :class="{ on: item.dictValue == tid }"
            v-for="(item, index) in navlist"
            @click="changetab(item.dictValue)"
            :key="index"
            >{{ item.dictName }}</a
          >
        </div>
      </div>
    </div> -->
      <div class="nav">
        <div class="title">{{leftNavName}}</div>
        <a
          :class="{ on: item.dictValue == tid }"
          v-for="(item, index) in navlist"
          @click="changetab(item.dictValue)"
          :key="index"
          >{{ item.dictName }}</a
        >
      </div>
      <div class="content">
        <div class="search">
          <el-form label-width="100px">
            <!-- <el-form-item label="文件类型：">
            <el-radio-group v-model="filetype">
              <el-radio
                v-for="(item, index) in filelist"
                :key="index"
                :label="item.label"
                >{{ item.name }}</el-radio
              >
            </el-radio-group>
          </el-form-item> -->
            <el-form-item label="关键字：">
              <el-input
                style="width:500px"
                placeholder="请输入关键字"
                clearable
                v-model="keyword"
              >
                <el-button
                  slot="append"
                  size="small"
                  type="primary"
                  icon="el-icon-search"
                  @click="search"
                ></el-button>
              </el-input>
            </el-form-item>
          </el-form>
          <div class="totalin">
            <span>已收录文件</span>
            <p>{{ total }}</p>
          </div>
        </div>
        <!-- 循环navlist 对应显示内容 -->
        <div class="tabdiv">
          <div
            class="policyli"
            @click="toinfo(item.id)"
            v-for="(item, index) in datalist"
            :key="index"
          >
            <b>{{ (pageno - 1) * 10 + index + 1 }}</b>
            <div>
              <h2>{{ item.zcfgmc }}</h2>
              <!-- <p>
              很多人在施工的时候都会选择安排一个监理的人员在一边进行监督，这类职业被称之为工程监理，这类职业的主要作用是为了对施工方起到一个规范的作用，下面就让河南工
              很多人在施工的时候都会选择安排一个监理的人员在一边进行监督，这类职业被称之为工程监理，这类职业的主要作用是为了对施工方起到一个规范的作用，下面就让河南工
            </p> -->
            </div>
            <span>{{ item.lrsj ? item.lrsj.split(" ")[0] : "" }}</span>
          </div>
        </div>
        <div class="pageno">
          <el-pagination
            background
            :current-page="pageno"
            @current-change="handleCurrentChange"
            layout="total, prev, pager, next, jumper"
            :total="total"
          ></el-pagination>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      keyword: "",
      // filetype: null,
      tid: "",
      pageno: 1,
      navlist: [],
      total: 0,
      datalist: [],
      leftNavName:''
      // filelist: [
      //   { label: null, name: "全部文件" },
      //   { label: 1, name: "法律" },
      //   { label: 2, name: "行政法规" },
      //   { label: 3, name: "国家部委规章" },
      //   { label: 4, name: "地方性法规" },
      //   { label: 5, name: "其他" }
      // ]
    };
  },
  watch: {
    $route: {
      handler() {
        this.tid = this.$route.query.tid ? this.$route.query.tid : "";
        this.pageno = this.$route.query.pageno - 0;
        this.keyword = this.$route.query.keyword || "";
        var nav = JSON.parse(localStorage.getItem("nav"));
        this.leftNavName = nav.filter(item => {
          return item.parent.code === "zcfglx";
        })[0].parent.name;
        if (this.tid || this.tid.length) {
          // 二级菜单时，获取companySummaryType
          
          var navlist = nav.filter(item => {
            return item.parent.code === "zcfglx";
          })[0].child;
          this.navlist = navlist;
        } else {
          this.tid = "";
        }

        this.getinfo();
      },
      immediate: true
    }
  },
  methods: {
    search() {
      this.$router.push({
        path: "/policy/policy",
        query: { tid: this.tid, pageno: 1, keyword: this.keyword }
      });
    },
    getinfo() {
      this.$get(
        "/website/zcfgPage?menuCode=zcfglx&lxId=" +
          this.tid +
          "&limit=10&page=" +
          this.pageno +
          "&zcfgmc=" +
          this.keyword
      ).then(res => {
        this.datalist = res.data.list;
        this.total = res.data.total;
      });
    },
    toinfo(id) {
      this.$router.push({
        path: "/policy/policyinfo",
        query: { tid: this.tid, id: id }
      });
    },
    handleCurrentChange(val) {
      // window.scrollTo(0, 0);

      this.$router.push({
        path: "/policy/policy",
        query: { tid: this.tid, pageno: val, keyword: this.keyword }
      });
    },
    changetab(index) {
      this.$router.push({
        path: "/policy/policy",
        query: { tid: index, pageno: 1 }
      });
    }
  }
};
</script>
<style scoped>
.search {
  width: 100%;
  position: relative;
  border-bottom: 1px solid rgb(138, 159, 197);
}
.search .totalin {
  text-align: right;
  position: absolute;
  right: 0;
  top: -10px;
}
.search .totalin p {
  color: #409eff;
  font-size: 24px;
  line-height: 24px;
}
.policyli {
  display: flex;
  justify-content: space-between;
  border-bottom: 1px dashed #ccc;
  padding: 9px 0;
  align-items: center;
  cursor: pointer;
}
.policyli b {
  width: 80px;
  text-align: center;
  font-size: 15px;
  font-weight: normal;
}
.policyli > div {
  flex: 1;
  padding-right: 30px;
}
.policyli > div h2 {
  font-size: 15px;
  font-weight: normal;
}
.policyli > div p {
  font-size: 16px;
  padding-top: 10px;
  line-height: 30px;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  overflow: hidden;
}
.policyli:hover {
  background: #fff;
}
.policyli span {
  width: 120px;
  text-align: center;
  font-size: 15px;
}
.pageno {
  padding-top: 20px;
  text-align: right;
}

.tabdiv {
  position: relative;
}

/* .content {
  width: 1200px;
  margin: 0 auto;
  padding: 20px 0;
} */
#secondnav {
  width: 100%;
  background: #fff;
  border-bottom: 1px solid rgb(138, 159, 197);
  box-sizing: border-box;
  height: 80px;
}
.secondnav {
  width: 1200px;
  margin: 0 auto;
  overflow: hidden;
}
.secondnav .title {
  font-weight: bold;
  float: left;
  padding: 0 25px;
  line-height: 75px;
  display: inline-block;
  font-size: 16px;
  border-bottom: 5px solid rgb(30, 69, 141);
  box-sizing: border-box;
}
.secondnav .nav {
  float: right;
  height: 80px;
  display: flex;
  align-items: center;
}
.secondnav .nav a {
  display: inline-block;
  padding: 10px 15px;
  background: rgb(102, 119, 170);
  margin-left: 20px;
  font-size: 16px;
  color: #fff;
}
.secondnav .nav a.on,
.secondnav .nav a:hover {
  background: #9c1f21;
}
.secondnav .mbx {
  float: left;
  padding-top: 33px;
  padding-left: 50px;
}
</style>
